
import { defineComponent, PropType } from 'vue'

type Images = 'cup' | 'mail' | 'order' | 'router' | 'table'

export default defineComponent({
  name: 'EmptyComp',

  props: {
    image: { type: String as PropType<Images>, default: '' },
    desc: { type: String, default: '' },
    confirmButtonText: { type: String, default: '确定' },
    confirmButtonShow: { type: Boolean, default: true }
  }
})
